import { WaterBoilerOffIcon } from './WaterBoilerOffIcon';

/**
 * author: Michael Irigoyen
 * id E7515B82-DE9D-4053-9D48-297511ED48E5
 * name water-boiler-off
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-boiler-off.svg
 * tags
 * - Home Automation 
 */
export const WaterHeaterOffIcon = WaterBoilerOffIcon;
export default WaterHeaterOffIcon